import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { effect, inject } from '@angular/core';
import { UserService } from '../services/user.service';

export const authGuard: CanActivateFn = (route, state) => {

  const router: Router = inject(Router);
  const authService: AuthService = inject(AuthService);
  const userService: UserService = inject(UserService);
  const allowAccess = authService.isAuthenticated() && userService.isAuthorized();

    if (!allowAccess) {
      if (!authService.isAuthenticated()) {
        router.navigate(['/unauthenticated']);
      } else if (!userService.isAuthorized()) {
        router.navigate(['/unauthorized']);
      }
    }
  return true;
};



